import React from "react";

// Reusable empty state for admin panels: a soft icon, a title, an optional
// subtitle telling the admin what to do next, and an optional action element.
const EmptyState = ({ icon: Icon, title, subtitle, action, compact = false }) => (
  <div
    className={`flex flex-col items-center justify-center rounded-2xl border border-theme-chatDivider bg-theme-secondaryBackground px-6 text-center ${
      compact ? "py-10" : "py-14"
    }`}
  >
    {Icon && (
      <span className="mb-3 flex h-12 w-12 items-center justify-center rounded-full bg-theme-tertiaryBackground text-theme-placeholder">
        <Icon size={22} />
      </span>
    )}
    <p className="text-sm font-semibold text-theme-secondaryText">{title}</p>
    {subtitle && (
      <p className="mt-1 max-w-sm text-xs leading-relaxed text-theme-placeholder">
        {subtitle}
      </p>
    )}
    {action && <div className="mt-4">{action}</div>}
  </div>
);

export default EmptyState;
